import React, { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateSlug, updateCategory ,updateImage ,updateTitle , updateContent,updateBlogImage } from "../redux/blog/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
function PreviewBlog() {
  const dispatch = useDispatch();
  const { slug, category, image, title, content } = useSelector(
    (state) => state.blog
  );
  console.log(content);
  //api request states.
  const [publishError, setPublishError] = useState(null);
  const [successMsg, SetSuccessMsg] = useState(false);

  const handlesubmit = async (e) => {
    e.preventDefault();

    try {
      console.log({
        title,
        slug,
        featureImage: image,
        category,
        content,
      });
      const res = await fetch(
        `${BASE_URL}/api/blog/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title,
            slug,
            featureImage: image,
            category,
            content,
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        setPublishError(data.message);
        return;
      }
      if (res.ok) {
        setPublishError(null);
        SetSuccessMsg(true);
      }
    } catch (error) {
      setPublishError(error.message);
    }
  };
  const handleEmptyField = ()=>{
    dispatch(updateImage(""));
    dispatch(updateCategory("software"));
    dispatch(updateSlug(""));
    dispatch(updateTitle(""));
    dispatch(updateContent(""));
    dispatch(updateBlogImage(""));
  }
  return (
    <>
      <div>
        <div className="container blog-section ">
          <div className="row blogpagehero">
            <div className="col-lg-6 blogpagetitle-container">
              <h1 className="blogpagetitle">{title}</h1>
              <div className="blogpagedetails">
                <div className="categoryitem software ">{category}</div>
                <div className="date">01/01/01</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cardimage">
                <img src={image} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="container blogpagecontent">
          <div className="row">
            <div
              className="col-lg-8 blog-content"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
            <div className="col-lg-4 blog-menu-container"></div>
          </div>
          {publishError && <div className="formhandle">{publishError}</div>}
          {successMsg && (
            <div className="success">Post Created SuccessFully !</div>
          )}
          {
            !successMsg ? <div className="text-center mt-5 mb-3">
            <input
              type="submit"
              onClick={handlesubmit}
              className="formbtn"
              value="Upload Blog"
            />
          </div> : <div className="mt-4 mb-5 text-center" onClick={handleEmptyField}>
            <Link to="/" className="formbtn">Browse Blogs</Link>
          </div>
          }  
        </div>
      </div>
    </>
  );
}

export default PreviewBlog;
